import IframeFileGenerator from "./IframeGenerator";
export default IframeFileGenerator;
